import { useEffect, useState } from "react";
import SearchBar from "./SearchBar";
import ContactSummary from "./ContactSummary";
import ContactGrid from "./ContactGrid";
import { getContactSummary, getContactGridData } from "../service/adminContact_service";
import "../styles/adminContactStyles.css";

const ContactList = () => {
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    status: null
  });

  const [contacts, setContacts] = useState([]);
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchContactsSummary = async () => {
    try {
      setLoading(true);
      const response = await getContactSummary();
      setSummary(response.data);
    } finally {
      setLoading(false);
    }
  };

  const fetchContacts= async () => {
    try {
      setLoading(true);
      const response = await getContactGridData(filters.name, filters.email, filters.status);
      setContacts(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactsSummary();
    
  }, []);

  useEffect(()=>{
    fetchContacts();
  },[filters.status])

  return (
    <>

        <SearchBar
        filters={filters}
        setFilters={setFilters}
        onSearch={fetchContacts}
      />
 


        {summary?.length > 0 && 
      <ContactSummary
        summary={summary}
        onStatusClick={(status) =>
          setFilters(prev => ({ ...prev, status }))
        }
      />}

      <div className="row">
  <div className="col-sm-12 ps-0">
    <ContactGrid 
    rowData={contacts}
        loading={loading}/>
  </div>
</div>
    </>
  );
};

export default ContactList;